"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MARKETING_KEY = exports.PRIVACY_KEY = exports.USE_KEY = void 0;
exports.USE_KEY = '이용약관';
exports.PRIVACY_KEY = '개인정보처리방침';
exports.MARKETING_KEY = '마케팅 활용 동의서';
